import { render, staticRenderFns } from "./opportunities.vue?vue&type=template&id=2640f79d"
import script from "./opportunities.vue?vue&type=script&lang=js"
export * from "./opportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports